// extracted by mini-css-extract-plugin
module.exports = {"descriptionToggleButton":"As"};